// @ts-strict-ignore
import { Button } from '@coast/schemas';
import React, { useCallback, useContext, useMemo } from 'react';
import { View } from '@shared/components/View';
import { CardChannelContext } from '@shared/components/blocks/contexts/channel';
import { CardFormContext } from '@shared/components/blocks/contexts/form';
import { executeActions } from '@shared/components/blocks/lib/button/actions';
import { MBButton, MBButtonProps } from '@shared/components/button';
import { useToast } from '@shared/components/toast';
import { useCardDefinition, useCardTemplates } from '@shared/scenes/cards/hooks';
import { useNavigator } from '@shared/util/navigation';

interface Props {
  button: Button;
  card: MBAPI.Card;
}

function makeButtonProps(button: Button): MBButtonProps {
  return {
    leftIcon: button.icon,
    title: button.label,
    size: button.size || 'normal',
    theme: button.style === 'secondary' ? 'outline' : 'normal',
    style: { marginHorizontal: 4 }, // this spaces out buttons in the same row
  };
}

export function MBButtonBlockButton({ button, card }: Props) {
  const channel = useContext(CardChannelContext);
  const { cardDefinition } = useCardDefinition(channel?.id, channel?.workflowTemplateId);
  const templates = useCardTemplates(cardDefinition);
  const formContext = useContext(CardFormContext);
  const toast = useToast();
  const navigator = useNavigator();
  const onPress = useCallback(
    (node?: React.Component) =>
      executeActions(
        button.actions,
        card,
        channel.slug,
        formContext,
        toast,
        templates,
        navigator,
        node,
      ),
    [button.actions, card, channel.slug, formContext, navigator, templates, toast],
  );
  const props = useMemo(() => makeButtonProps(button), [button]);
  return (
    <View style={{ maxWidth: 320 }} flex>
      <MBButton {...props} onPress={onPress} />
    </View>
  );
}
